import { PagedSingleSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { contactFilterService } from "../shared/api/contactFilterService";
import { ContactFilterType } from "../shared/types";

interface Props {
	label: string;
	name: string;
	required?: boolean;
	types?: ContactFilterType[];
	clearable?: boolean;
}

const fetcher = (search: string, page: number, types: ContactFilterType[]) =>
	contactFilterService.options(search, page, types).then((response) => response.data);

export const ContactFilterSelectField: FC<Props> = ({
	clearable,
	label,
	name,
	required = false,
	types = ["onDemand", "system", "personal", "public"],
}) => {
	return (
		<PagedSingleSelectField
			label={label}
			name={name}
			fetchConfig={laravelSelectFetchConfig(contactFilterService.optionsKey(types), (search, page) =>
				fetcher(search, page, types),
			)}
			required={required}
			clearable={clearable}
		/>
	);
};
